import { ImageUploaderData } from '@/models/file';

// eslint-disable-next-line import/prefer-default-export
export const getImage = (imagePath: string) => new Promise<HTMLImageElement>((resolve, reject) => {
  const img = new Image();

  img.onload = () => {
    resolve(img);
  };

  img.onerror = () => {
    reject(new Error('Cannot load image'));
  };

  img.src = imagePath;
});

export const getFileData = (file: File) => new Promise<ImageUploaderData>((resolve, reject) => {
  const reader = new FileReader();

  reader.onload = (event: ProgressEvent<FileReader>) => {
    const dataURI = event.target ? event.target.result : null;
    // console.log(dataURI);
    if (dataURI) {
      return resolve({
        path: dataURI,
        filename: file.name,
        date: file.lastModified,
        file,
      });
    }
    return reject(new Error('cannot parse this file'));
  };

  reader.onerror = () => {
    reject(new Error('cannot parse this file'));
  };

  reader.readAsDataURL(file);
});

export const getImageDataUri = (file: File) => new Promise<ImageUploaderData>((resolve, reject) => {
  const reader = new FileReader();

  reader.onload = (event: ProgressEvent<FileReader>) => {
    const dataURI = event.target ? event.target.result : null;
    // console.log(dataURI);
    if (dataURI) {
      return resolve({
        path: dataURI,
        filename: file.name,
        date: file.lastModified,
        file,
      });
    }
    return reject(new Error('cannot parse this file'));
  };

  reader.onerror = () => {
    reject(new Error('cannot parse this file'));
  };

  reader.readAsDataURL(file);
});
